export default __webpack_public_path__ + "5fa5773f098e49ea5796fb32c7e60c5c.png";